import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function UpconversionMaterialsUseCase() {
  return (
    <>
    <section
      id="upconversion-materials"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Upconversion Materials
          </h1>
          <p className="text-slate-300 space-y-2">
            Upconversion materials absorb two or more low-energy (long-wavelength) photons and emit a single higher-energy (short-wavelength) photon.
            This process enables novel applications in bioimaging, photovoltaics, sensing, and photocatalysis by accessing visible or UV emission from NIR excitation.

            <br /><br />

            While lanthanide-doped materials dominate traditional upconversion, organic and hybrid systems offer solution-processability, tunability, and lower toxicity.
            Photon upconversion via triplet–triplet annihilation is a leading mechanism in organic systems, requiring careful pairing of sensitiser and annihilator molecules with aligned energy levels and long triplet lifetimes.
          </p>
        </div>

        {/* How Apoello Helps */}
{/* How DiaDEM™ helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Search singlet and triplet energy levels across millions of molecules for potential sensitiser–emitter pairs.
    </li>
    <li>
      Identify candidates with efficient intersystem crossing and spectral overlap.
    </li>
    <li>
      Filter by solubility, absorption range, and chemical structure.
    </li>
    <li>
      Order material candidates directly to the lab.
    </li>
  </ul>
</div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            Organic upconversion holds the key to unlocking low-intensity light harvesting and deep-tissue imaging — but material discovery is slow and empirical.
            DiaDEM™ enables targeted virtual screening of both sensitisers and annihilators, accelerating design of next-gen upconversion materials without wasteful lab trial-and-error.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
